var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { staticClass: "row mt-3" }, [
        _c("div", { staticClass: "col-lg-12 text-center" }, [
          _c(
            "button",
            {
              staticClass: "btn",
              class: _vm.classes,
              staticStyle: { cursor: "pointer" },
              attrs: { type: "button" },
              on: { click: _vm.copyLink }
            },
            [_vm._v(_vm._s(_vm.T.copyLink[_vm.lang]))]
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("input", {
            staticClass: "hidden",
            attrs: { id: "url", type: "text" }
          })
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-04da712d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04da712d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/Link.vue
// module id = 34
// module chunks = 0